import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook para corrigir problemas de layout em mobile após navegação
 * Especialmente útil após login quando o header pode sobrepor o conteúdo
 */
export const useFixMobileLayout = () => {
  const location = useLocation();

  useEffect(() => {
    // Função para forçar recálculo do layout
    const fixLayout = () => {
      // Forçar reflow do DOM
      document.body.style.display = 'none';
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      document.body.offsetHeight; // Trigger reflow
      document.body.style.display = '';
      
      // Dispatch resize event
      window.dispatchEvent(new Event('resize'));
      
      // Scroll to top
      window.scrollTo(0, 0);
      
      // Forçar recálculo de altura da toolbar
      const toolbar = document.querySelector('main .MuiToolbar-root');
      if (toolbar) {
        (toolbar as HTMLElement).style.display = 'none';
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        (toolbar as HTMLElement).offsetHeight; // Trigger reflow
        (toolbar as HTMLElement).style.display = '';
      }
    };

    // Executar fix com pequeno delay para garantir que DOM está pronto
    const timer1 = setTimeout(fixLayout, 10);
    const timer2 = setTimeout(fixLayout, 100);
    const timer3 = setTimeout(fixLayout, 300);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, [location.pathname]); // Re-executar quando mudar de rota
};